import { motion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </Tag>
  );
};

export const SectionHead = ({ index, label, title, className = "" }) => (
  <div className={`mb-16 md:mb-24 ${className}`}>
    <Reveal>
      <p className="overline-label" data-testid={`section-${index}-label`}>
        {index} — {label}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-6 font-serif text-4xl md:text-6xl font-light tracking-tight leading-[1.05] max-w-3xl">
        {title}
      </h2>
    </Reveal>
  </div>
);

export default Reveal;
